import React from "react";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  buttonWrapper: {
    width: "40px",
    height: "40px",
    margin: "30px",
    backgroundColor: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "200ms",
    cursor: "pointer",
    color: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: "white !important",
    },
  },
  btnGroup: {
    display: "flex",
    justifyContent: "center",
  },
}));

const NavButton = ({ prev, next }) => {
  const classes = useStyles();

  return (
    <div className={classes.btnGroup}>
      <Box
        boxShadow={3}
        borderRadius="50%"
        onClick={() => prev()}
        className={`${classes.buttonWrapper} ${classes.buttonWrapperPrev}`}
      >
        <NavigateBeforeIcon onClick={() => prev()} />
      </Box>
      <Box
        boxShadow={3}
        borderRadius="50%"
        className={`${classes.buttonWrapper} `}
      >
        <NavigateNextIcon onClick={() => next()} />
      </Box>
    </div>
  );
};

export default NavButton;
